import firebase from 'firebase/app';
import { action, computed, observable } from 'mobx';
import { AbstractModel } from './AbstractModel';
import { trackEvent } from '../lib/tracking';

export interface Picture {
  updatedAt: string;
  url: string;
  user: string; //reference
  votesCount: number;
}

export const STORAGE_IMG_PREFIX = '/images/';

export class UserPicturesModel extends AbstractModel {
  @observable
  isLoading = true;

  @observable
  pictures: Picture[] = [];

  @action
  setPictures(pictures: any[]) {
    this.pictures = pictures;
    // console.log("pictures set", { pictures });
    this.isLoading = false;
  }

  @action
  removeAllUserPictures() {
    trackEvent('remove_all_user_pictures');
    this.rootStore.firebase.removeAllUserPictures().catch((reason) => console.error(reason));
    this.pictures = []; // optimistic update
  }

  @computed get leftPic(): Picture | undefined {
    return this.pictures.length > 0 ? this.pictures[0] : undefined;
  }

  @computed get rightPic(): Picture | undefined {
    return this.pictures.length > 1 ? this.pictures[1] : undefined;
  }

  private get currentUserRef() {
    return this.rootStore.currentUser.currentUserRef;
  }

  ensureUserPictures = async () => {
    this.isLoading = true;
    try {
      const res: firebase.firestore.QuerySnapshot = await this.rootStore.firebase.pictures
        .where('user', '==', this.currentUserRef)
        .get();

      if (res.docs) {
        this.setPictures(res.docs.map((doc) => doc.data()));
      }
    } catch (error) {
    } finally {
      this.isLoading = false;
    }
  };

  // uploadUserPhotoFlow = async (photo: any) => {
  //   const { uploadPhoto, addUserPicturesCount, createPictureRecord } = this.rootStore.firebase;
  //   const userId = this.rootStore.currentUser.isAuthenticated;

  //   if (!userId) {
  //     console.error('missing user');
  //   }

  //   const newImageRef = await uploadPhoto(photo);

  //   const url = await newImageRef.getDownloadURL();
  //   const promise1 = createPictureRecord(url, this.currentUserRef);
  //   const promise2 = addUserPicturesCount(this.currentUserRef);
  //   await Promise.all([promise1, promise2]);
  // };

  onUploadedPhotoUrl = async (url: string) => {
    trackEvent('photo_uploaded');
    const { addUserPicturesCount, createPictureRecord } = this.rootStore.firebase;
    await Promise.all([createPictureRecord(url, this.currentUserRef), addUserPicturesCount(this.currentUserRef)]);
  };
}
